export const SalesDashboardComponent: ng.IComponentOptions = {
  bindings: {},
  templateUrl: 'analytics/components/sales-dashboard/sales-dashboard.html',
  controller: class SalesDashboardController implements ng.IController {},
};
